import { Grid, GridItem, Link, Text } from '@chakra-ui/react';
import NextLink from 'next/link';
import { useRouter } from 'next/router';

import { InventoryTitles } from '@/utils/models/inventory-items';

interface TitlesListProps {
  titles: InventoryTitles[];
}

export const TitlesList = ({ titles }: TitlesListProps) => {
  const { pathname } = useRouter();

  return (
    <Grid
      as="ul"
      gridTemplateColumns={`repeat(auto-fill, minmax(min(100%, max(250px, 100%/4)), 1fr))`}
      gap={{ base: 4 }}
      listStyleType="none"
      mt={{ base: 8, sm: 0 }}
      ml={{ sm: 14 }}
      w="100%"
    >
      {titles.map(({ title, slug }) => {
        return (
          <GridItem as="li" key={title}>
            <Link as={NextLink} href={`${pathname}/${slug}`}>
              <Text
                as="span"
                variant={{
                  base: 'text-md/lineHeight-6/font-medium',
                }}
                color="purple.400"
                _hover={{
                  color: 'violet.500',
                }}
                textTransform="capitalize"
              >
                {title}
              </Text>
            </Link>
          </GridItem>
        );
      })}
    </Grid>
  );
};
